var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-badge',{staticClass:"quoted-badge",attrs:{"size":"small","value":"引用済","hidden":!_vm.isQuotedItem}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }